var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("a-modal", {
    attrs: {
      title: _vm.$t("配置模板"),
      visible: _vm.dialogVisible,
      okText: _vm.$t("确认"),
      cancelText: _vm.$t("取消"),
      width: 620,
      maskClosable: false
    },
    on: {
      ok: _vm.handleSure,
      cancel: _vm.cancelFunc
    }
  }, [_c("a-form-model", {
    ref: "formRef",
    attrs: {
      model: _vm.formData,
      rules: _vm.rules,
      "label-col": {
        span: 4
      },
      "wrapper-col": {
        span: 16
      },
      hideRequiredMark: ""
    }
  }, [_c("a-form-model-item", {
    attrs: {
      prop: "selectedTemplates",
      label: _vm.$t("选择模板"),
      hasFeedback: ""
    }
  }, [_c("a-select", {
    staticStyle: {
      width: "100%"
    },
    attrs: {
      mode: "multiple"
    },
    model: {
      value: _vm.formData.selectedTemplates,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "selectedTemplates", $$v);
      },
      expression: "formData.selectedTemplates"
    }
  }, _vm._l(_vm.templateOptions, function (item) {
    return _c("a-select-option", {
      key: item.noticeTemplateId,
      attrs: {
        value: item.id
      }
    }, [_vm._v(" " + _vm._s(item.name) + " ")]);
  }), 1)], 1)], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };